import { __decorate, __metadata } from "tslib";
import { IsNotEmptyObjectWithLVS } from '@goparrot/common';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsBoolean, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, IsUrl, MaxLength } from 'class-validator';
import { WebMerchantExposeGroup, WebMerchantMenuItemTypeEnum } from '../interface';
export class ReadWebMerchantAppAccountMenuItemDto {
}
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "activeItem", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Boolean, example: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsBoolean({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Boolean)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "guestMenu", void 0);
__decorate([
    ApiProperty({ enum: Object.values(WebMerchantMenuItemTypeEnum), example: WebMerchantMenuItemTypeEnum.LOCATION }),
    IsNotEmpty({ always: true }),
    IsEnum(WebMerchantMenuItemTypeEnum, { always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.PUT] }),
    __metadata("design:type", String)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "type", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object }),
    IsNotEmptyObjectWithLVS({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "image", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsString({ always: true }),
    MaxLength(50, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "title", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String, description: 'Item icon tint' }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsString({ always: true }),
    MaxLength(100, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "iconTint", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Object, description: 'container for item' }),
    IsNotEmptyObjectWithLVS({ always: true }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    __metadata("design:type", Object)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "container", void 0);
__decorate([
    ApiPropertyOptional({ type: () => Number, example: 0.5 }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsNumber({}, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", Number)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "opacityFill", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    IsUrl({ require_host: true }, { always: true }),
    MaxLength(500, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "externalLink", void 0);
__decorate([
    ApiPropertyOptional({ type: () => String }),
    Expose({ groups: [WebMerchantExposeGroup.MODEL, WebMerchantExposeGroup.READ, WebMerchantExposeGroup.CREATE, WebMerchantExposeGroup.UPDATE] }),
    IsOptional({ always: true }),
    IsUrl({ require_host: true }, { always: true }),
    MaxLength(500, { always: true }),
    __metadata("design:type", String)
], ReadWebMerchantAppAccountMenuItemDto.prototype, "internalLink", void 0);
//# sourceMappingURL=ReadWebMerchantAppAccountMenuItemDto.js.map